module.exports = __webpack_public_path__ + "img/SKMJ_crain2.52f2ec85.png";